//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RadialProgressBar from "vue-radial-progress";
import {mapGetters} from "vuex";
import MissionActivity from "@/components/mission/MissionActivity";
import Missions from "@/components/mission/Missions";

export default {
  name: "MissionsDashboard",

  components: {
    Missions,
    MissionActivity,
    RadialProgressBar,
  },

  data: () => ({
    user: {},
    totalAnnotations: 0,
    level: 1,
  }),

  mounted() {
    this.fetchMetrics();
  },

  computed: {
    username: function () {
      if (this.currentClient && Object.keys(this.currentClient).length !== 0) {
        if (this.currentClient.properties.firstName) {
          return this.currentClient.properties.firstName + " " + this.currentClient.properties.lastName;
        }
        return this.currentClient.properties.username;
      }
      return "John Doe";
    },
    ...mapGetters(["currentClient", "projectId", "missions"]),
    initial: function () {
      if (this.currentClient && Object.keys(this.currentClient).length !== 0) {
        return this.currentClient.properties.username.charAt(0);
      }
      return "@";
    },
    pendingMissions: function () {
      if (this.missions) {
        return this.missions.length;
      }
      return 0;
    },
    closedMissions: function () {
      if (this.missions) {
        return this.missions.length;
      }
      return 0;
    },
    performance: function () {
      let performanceOutput = "...";
      if (this.missions) {
        let performance = 0;
        this.missions.forEach((mission) => {
          let missionPerf = 0;
          if (mission.contextParameters.mission && mission.contextParameters.mission.evaluation_result) {
            const evalResults = Object.values(mission.contextParameters.mission.evaluation_result);
            if (evalResults.length !== 0) {
              const initialPerf = evalResults[0]['main_result'];
              const finalPerf = evalResults[evalResults.length - 1]['main_result'];
              missionPerf = finalPerf - initialPerf;
            }
          }
          performance += missionPerf;
        });
        if (performance > 0) {
          performanceOutput = (performance * 100).toString() + ' %';
        }
      }
      return performanceOutput;
    },
    levelProgress: function () {
      return this.level * 10;
    },
  },

  methods: {
    fetchMetrics() {
      if (this.projectId) {
        this.$refs.fetchMetrics.params = {};
        this.$refs.fetchMetrics.params.all = false;
        this.$refs.fetchMetrics
            .get()
            .then(response => {
              if (response && response.hits) {
                this.totalAnnotations = response.hits.total;
                if (this.totalAnnotations === 0) {
                  this.level = 1;
                } else {
                  this.level = Math.log10(this.totalAnnotations).toFixed(0);
                }
              }
            });
      }
    },
  }
}
